"use client";

import { c as _c } from "react/compiler-runtime";
import { Link } from "@/navigation";
import { useLocale, useTranslations } from "next-intl";
import { getSocialProfiles } from "@/lib/social-profiles";
import { CookieSettingsLink } from "@/components/consent/CookieBanner";
import MadeWithLine from "@/components/upload/MadeWithLine";
import { MADE_WITH_SPOTS, type MadeWithArm } from "@/lib/made-with";
import { getUploadWindow } from "@/lib/upload-window";
interface FooterProps {
  /** Links to the guides and the comparison. Off on guest upload pages. */
  hasSiteLinks?: boolean;
  /**
   * Set only by the guest upload page: arm B of «Made with Guest.Gallery»
   * (approval 316) shows the line above the © row, unless the event has closed
   * (the closed gallery shows it instead).
   */
  guestPage?: {
    madeWithArm: MadeWithArm;
    archivesAt: string | null;
  };
}
export default function Footer(t0) {
  const $ = _c(48);
  const {
    hasSiteLinks: t1,
    guestPage
  } = t0;
  const hasSiteLinks = t1 === undefined ? false : t1;
  const t = useTranslations("Footer");
  const t2 = useLocale();
  let t3;
  if ($[0] !== t2) {
    t3 = getSocialProfiles(t2);
    $[0] = t2;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  const socialProfiles = t3;
  let t4;
  if ($[2] !== guestPage) {
    t4 = guestPage?.madeWithArm === MADE_WITH_SPOTS.guestFooter && !getUploadWindow({
      archivesAt: guestPage.archivesAt
    }).isArchived;
    $[2] = guestPage;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  const showsMadeWith = t4;
  let t5;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <hr className="" />;
    $[4] = t5;
  } else {
    t5 = $[4];
  }
  let t6;
  if ($[5] !== showsMadeWith) {
    t6 = showsMadeWith && <MadeWithLine spot={MADE_WITH_SPOTS.guestFooter} className="-mb-4 self-start" />;
    $[5] = showsMadeWith;
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  let t7;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = new Date().getFullYear();
    $[7] = t7;
  } else {
    t7 = $[7];
  }
  let t8;
  if ($[8] !== t) {
    t8 = t("allRightsReserved");
    $[8] = t;
    $[9] = t8;
  } else {
    t8 = $[9];
  }
  let t9;
  if ($[10] !== t8) {
    t9 = <p>© {t7} Guest.Gallery, {t8}</p>;
    $[10] = t8;
    $[11] = t9;
  } else {
    t9 = $[11];
  }
  let t10;
  if ($[12] !== hasSiteLinks || $[13] !== t) {
    t10 = hasSiteLinks ? <><Link className="underline" href="/blog">{t("guides")}</Link><Link className="underline" href="/sammenligning">{t("comparison")}</Link></> : null;
    $[12] = hasSiteLinks;
    $[13] = t;
    $[14] = t10;
  } else {
    t10 = $[14];
  }
  let t11;
  if ($[15] !== t) {
    t11 = t("privacyPolicy");
    $[15] = t;
    $[16] = t11;
  } else {
    t11 = $[16];
  }
  let t12;
  if ($[17] !== t11) {
    t12 = <Link className="underline" href="/privacy-policy">{t11}</Link>;
    $[17] = t11;
    $[18] = t12;
  } else {
    t12 = $[18];
  }
  let t13;
  if ($[19] !== t) {
    t13 = t("termsAndConditions");
    $[19] = t;
    $[20] = t13;
  } else {
    t13 = $[20];
  }
  let t14;
  if ($[21] !== t13) {
    t14 = <Link className="underline" href="/terms-and-conditions">{t13}</Link>;
    $[21] = t13;
    $[22] = t14;
  } else {
    t14 = $[22];
  }
  let t15;
  let t16;
  if ($[23] === Symbol.for("react.memo_cache_sentinel")) {
    t15 = <CookieSettingsLink className="text-left underline" />;
    t16 = <a className="underline" href="https://replysky.com/?utm_source=guestgallery&utm_medium=referral&utm_campaign=footer" target="_blank" rel="noopener noreferrer">Replysky</a>;
    $[23] = t15;
    $[24] = t16;
  } else {
    t15 = $[23];
    t16 = $[24];
  }
  let t17;
  if ($[25] !== socialProfiles.instagram) {
    t17 = <a className="underline" href={socialProfiles.instagram} target="_blank" rel="noopener noreferrer">Instagram</a>;
    $[25] = socialProfiles.instagram;
    $[26] = t17;
  } else {
    t17 = $[26];
  }
  let t18;
  if ($[27] !== socialProfiles.facebook) {
    t18 = <a className="underline" href={socialProfiles.facebook} target="_blank" rel="noopener noreferrer">Facebook</a>;
    $[27] = socialProfiles.facebook;
    $[28] = t18;
  } else {
    t18 = $[28];
  }
  let t19;
  if ($[29] !== t10 || $[30] !== t12 || $[31] !== t14 || $[32] !== t17 || $[33] !== t18) {
    t19 = <div className="flex flex-col md:flex-row gap-4 md:max-lg:flex-wrap md:max-lg:gap-y-2 md:max-lg:whitespace-nowrap">{t10}{t12}{t14}{t15}{t16}{t17}{t18}</div>;
    $[29] = t10;
    $[30] = t12;
    $[31] = t14;
    $[32] = t17;
    $[33] = t18;
    $[34] = t19;
  } else {
    t19 = $[34];
  }
  let t20;
  if ($[35] !== t19 || $[36] !== t9) {
    t20 = <div className="flex justify-between gap-4 flex-wrap">{t9}{t19}</div>;
    $[35] = t19;
    $[36] = t9;
    $[37] = t20;
  } else {
    t20 = $[37];
  }
  let t21;
  if ($[38] !== t20 || $[39] !== t6) {
    t21 = <div className="p-4  flex flex-col gap-8 mx-auto">{t5}{t6}{t20}</div>;
    $[38] = t20;
    $[39] = t6;
    $[40] = t21;
  } else {
    t21 = $[40];
  }
  let t22;
  if ($[41] !== t) {
    t22 = t("companyLine");
    $[41] = t;
    $[42] = t22;
  } else {
    t22 = $[42];
  }
  let t23;
  if ($[43] !== t22) {
    t23 = <div className="mx-4 text-sm text-gray-500">{t22}</div>;
    $[43] = t22;
    $[44] = t23;
  } else {
    t23 = $[44];
  }
  let t24;
  if ($[45] !== t21 || $[46] !== t23) {
    t24 = <div className=" w-full  py-8">{t21}{t23}</div>;
    $[45] = t21;
    $[46] = t23;
    $[47] = t24;
  } else {
    t24 = $[47];
  }
  return t24;
}